import _ from "underscore";
import UserSelectorGroupsStrategy from "./UserSelectorGroupsStrategy";
import HierarchySelectorUtil from "../../controls/selectorControls/hierarchy_selector_util";
import UserGroupSelectorTree from "../../hierarchySelector/userSelector/UserGroupSelectorTree";
import TreeNode from "../../hierarchySelector/tree/TreeNode";
import TreeNodeSet from '../../hierarchySelector/tree/TreeNodeSet'

ShowUserGroupsStrategy.USER_GROUP_NODE_LEVEL = 1;
ShowUserGroupsStrategy.USER_NODE_LEVEL = 2;
ShowUserGroupsStrategy.DISABLED_USER_NODE_LEVEL = 3;

ShowUserGroupsStrategy.noNodesMatchingSearchMessageKey = "users_selector.users_or_user_groups_no_results_in_search";
ShowUserGroupsStrategy.noSelectedNodesMessageKey = "users_selector.hide_not_selected.no_users_or_user_groups_selected";

export default function ShowUserGroupsStrategy( conf ) {
    UserSelectorGroupsStrategy.call(this);

    this.emptySelectionTooltipTextKey = conf && conf.emptySelectionTooltipTextKey ? conf.emptySelectionTooltipTextKey :
                                        window.EnabledFeatures.UGR && window.EnabledFeatures.TZG ? "mail_notifications.users_selector.tooltip.no_users_selected" :
                                        window.EnabledFeatures.TZG ? "mail_notifications.users_selector.tooltip.tgz_only.no_users_selected" :
                                        "mail_notifications.users_selector.tooltip.ug_only.no_users_selected";
    this.noNodesMatchingSearchMessageKey = conf && conf.noNodesMatchingSearchMessageKey ? conf.noNodesMatchingSearchMessageKey : ShowUserGroupsStrategy.noNodesMatchingSearchMessageKey;
    this.noSelectedNodesMessageKey = conf && conf.noSelectedNodesMessageKey ? conf.noSelectedNodesMessageKey : ShowUserGroupsStrategy.noSelectedNodesMessageKey;

    this.getGroupIdFromUserCallback = conf && conf.getGroupIdFromUserCallback ? conf.getGroupIdFromUserCallback : function(user) { return user.getUserGroupId(); };
}

ShowUserGroupsStrategy.prototype = new UserSelectorGroupsStrategy();

ShowUserGroupsStrategy.prototype.canExpandCollapseNodes = function() {
    return true;
};

ShowUserGroupsStrategy.prototype.createTree = function(rootNode, emptyMessageBuilder, collapsedNodeIds) {
    return new UserGroupSelectorTree(rootNode, emptyMessageBuilder, collapsedNodeIds, this.getGroupIdFromUserCallback);
};

ShowUserGroupsStrategy.prototype.isGroupNodeRendererNeeded = function() {
    return true;
};

ShowUserGroupsStrategy.prototype.makeSelectionFromNodeSet = function(nodeSet, isFullFormed, mapFirstLevelToSecond, groupType) {
    var selection = UserSelectorGroupsStrategy.prototype.makeSelectionFromNodeSet.call(this, nodeSet, isFullFormed, mapFirstLevelToSecond);
    selection.groupType = groupType;
    return selection;
};

ShowUserGroupsStrategy.prototype.makeOnlyUsersSelection = function(nodeSet) {
    var usersArray = [];
    _.each(nodeSet.getAllNodes(), function(node)
    {
        if (node.getType() == TreeNode.TYPE_USER)
            usersArray.push(node.getValue());
    });
    return usersArray;
};

/**
 * Returns all selected user. Includes users from selected groups
 * @param nodeSet
 * @returns {Array} all selected users
 */
ShowUserGroupsStrategy.prototype.makeAllSelectedUsersSelection = function(nodeSet) {
    var usersArray = [];

    function addUsersRecursive(node)
    {
        if (node.getType() == TreeNode.TYPE_USER)
            usersArray.push(node.getValue());
        else
            _.each(node.getChildren(), addUsersRecursive);
    }

    _.each(nodeSet.getAllNodes(), function(node)
    {
        addUsersRecursive(node);
    });

    return usersArray;
};

ShowUserGroupsStrategy.prototype.saveCollapsedNodesIntoCookies = function(tree, cookiesKey) {
    HierarchySelectorUtil.saveCollapsedNodesIntoCookies(tree, cookiesKey, TreeNode.TYPE_GROUP);
};

ShowUserGroupsStrategy.prototype.makeNodeSet = function(selection, rootNode) {
    let resultSet = HierarchySelectorUtil.makeNodeSetByTwoLevelSelection( selection, rootNode, "g", "u" );
    resultSet.addAll(HierarchySelectorUtil.selectNodesParents(resultSet, ShowUserGroupsStrategy.DISABLED_USER_NODE_LEVEL))
    return resultSet
};

ShowUserGroupsStrategy.prototype.getUserNodeLevel = function () {
    return ShowUserGroupsStrategy.USER_NODE_LEVEL;
};



// WEBPACK FOOTER //
// ./web/js/usersSelector/userSelectorGroupsStrategies/ShowUserGroupsStrategy.js